import React from 'react';
import { XIcon } from 'lucide-react';
const pains = [{
  title: '😰 Jeden Tag dieselbe Frage: "Was darf ich überhaupt noch essen?"',
  desc: 'Diabetes, Glutenintoleranz, Laktoseintoleranz — die Verbotsliste wird länger. Die Freude am Essen kürzer.'
}, {
  title: '🩺 Ihr Körper sendet Alarmsignale',
  desc: 'Blutzuckerschwankungen. Verdauungsprobleme. Chronische Müdigkeit. Schlechter Schlaf. Und keine klare Lösung in Sicht.'
}, {
  title: '📱 Zu viele widersprüchliche Informationen',
  desc: 'Low Carb. Keto. Intervallfasten. Sie lesen alles — und am Ende wissen Sie weniger als vorher.'
}, {
  title: '😩 Das Gefühl, für immer auf Genuss verzichten zu müssen',
  desc: 'Fade Diät. Immer dieselben drei Gerichte. Kein Dessert. Kein echtes Essen mehr. Das muss nicht so sein.'
}];
export function PainSection() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-113">
      <div className="max-w-xl mx-auto" data-id="element-114">
        <h2 className="text-2xl sm:text-3xl font-serif font-bold text-center mb-6 sm:mb-8 text-brand-text-main" data-id="element-115">
          Erkennen Sie sich wieder?
        </h2>

        <div className="space-y-3 sm:space-y-4" data-id="element-116">
          {pains.map((pain, i) => <div key={i} className="flex gap-3 items-start bg-white p-4 sm:p-5 rounded-xl border border-brand-sage/20 shadow-sm" data-id="element-117">
              <div className="mt-0.5 bg-red-50 p-1.5 rounded-full shrink-0" data-id="element-118">
                <XIcon className="w-4 h-4 text-red-500" strokeWidth={3} data-id="element-119" />
              </div>
              <div data-id="element-120">
                <h3 className="text-sm sm:text-base font-bold text-brand-text-main mb-1" data-id="element-121">
                  {pain.title}
                </h3>
                <p className="text-xs sm:text-sm text-brand-text-muted leading-relaxed" data-id="element-122">
                  {pain.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}